import { useState, useEffect, useCallback } from 'react';
import PagedResponseDefault from 'components/defaults/PagedResponseDefault';
import listSqlPipelineExecutions from 'api/SqlPipeline/listSqlPipelineExecutions';
import startDataProcessingPipeline from 'api/SqlPipeline/startPipeline';
import Spinner from 'components/loader/Spinner';
import { useAlert } from 'components/message/AlertContext';
import { NButton, NTable } from '@innersource-nn/novoui-react';
import useClient from 'api/client';
import { Pipeline } from 'types/Pipeline';

const columns = [
    { header: 'Name', key: 'name' },
    { header: 'Start Date', key: 'startDate' },
    { header: 'End Date', key: 'stopDate' },
    { header: 'Status', key: 'status' },
];

interface ExecutionProps {
    pipeline: Pipeline;
}
const PipelineExecutions = ({ pipeline }: ExecutionProps) => {
    const { openAlert } = useAlert();
    const client = useClient();

    const [items, setItems] = useState(PagedResponseDefault);
    const [loading, setLoading] = useState(true);

    const fetchItems = useCallback(async () => {
        setLoading(true);
        const response = await client.query(
            listSqlPipelineExecutions(pipeline.sqlPipelineUri, 'prod'),
        );
        if (!response.errors) {
            setItems(response.data.listSqlPipelineExecutions);
        }
        setLoading(false);
    }, [client, pipeline.sqlPipelineUri]);

    const runPipeline = async () => {
        setLoading(true);
        const response = await client.mutate(
            startDataProcessingPipeline(pipeline.sqlPipelineUri),
        );
        if (!response.errors) {
        } else {
            openAlert({
                message: `Failed starting  pipeline, received ${response.errors[0].message}`,
                severity: 'alert',
            });
        }
        setLoading(false);
    };

    useEffect(() => {
        if (client) {
            fetchItems();
        }
    }, [client, fetchItems]);
    return (
        <div>
            {loading ? (
                <Spinner />
            ) : (
                <div>
                    <div className="flex gap-4 justify-end">
                        <NButton
                            leftIcon="refresh"
                            onClick={fetchItems}
                            variant="fill"
                            square
                        >
                            Refresh
                        </NButton>
                        <NButton
                            leftIcon="playSelected"
                            onClick={runPipeline}
                            variant="outline"
                            square
                        >
                            Start
                        </NButton>
                    </div>
                    <NTable
                        rowKey="name"
                        headers={columns}
                        columnBorder={true}
                        items={items.nodes}
                    />
                </div>
            )}
        </div>
    );
};

export default PipelineExecutions;
